import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { TagsEditTemplate } from 'components/Templates'

const TagsEdit: FC = () => {
  const path = useSelector((state: State) => state.router.location.pathname)
  const isCreatePage = path === '/admin/master/tags/create'
  const id = isCreatePage ? undefined : path.split('/admin/master/tags/')[1] ?? undefined

  return (
    <Layout title={'お店のオススメポイントを登録する'}>
      <TagsEditTemplate isCreatePage={isCreatePage} id={id} />
    </Layout>
  )
}

export default TagsEdit
